import { Form, Formik } from "formik";
import Button from "../../../shared/ui/Button";
import DateTimePickerBlockFormik from "../../../shared/ui/Form/DateTimePickerBlockFormik";
import FormikLabeledTextArea from "../../../shared/ui/Form/FormikLabeledTextArea";
import { ReminderFormSchema } from "../../../shared/ui/Form/schema";
/* @TODO => take this form minutes @habib610 Thu June 05,2025 */
const ReminderForm = ({ onSuccess }) => (
    <Formik
        initialValues={{
            message: "",
            date: new Date(),
            hour: 10,
            minutes: 0,
        }}
        validationSchema={ReminderFormSchema}
        onSubmit={(values) => onSuccess(values)}
    >
        <Form className="flex flex-col gap-1 p-3">
            <FormikLabeledTextArea
                name="message"
                label="Message"
                required
                rows="2"
            />
            <DateTimePickerBlockFormik
                label="Reminder Date"
                dateName="date"
                hourName="hour"
                minuteName="minutes"
                maxDate={
                    new Date(
                        new Date().getFullYear(),
                        new Date().getMonth() + 1,
                        new Date().getDate()
                    )
                }
            />
            <Button type="submit" className="w-full mt-2">
                Add Reminder
            </Button>
        </Form>
    </Formik>
);

export default ReminderForm;
